import "./i18n";
import "./App.css";

import { Routes, Route } from "react-router-dom";

import MainLayout from "./components/MainLayout";

import LandingPage from "./components/LandingPage";
import Contact from "./components/Contact";
import Services from "./components/Services";
import DiscoverPage from "./components/Discover";
import Policies from "./components/Policies";
import Terms from "./components/Terms";
import Cookie from "./components/Cookies";

function App() {
  return (
    <Routes>

      {/* ALL VALID ROUTES */}
      <Route path="/:lang" element={<MainLayout />}>

        {/* HOME */}
        <Route index element={<LandingPage />} />

        {/* PAGES */}
        <Route path="contact" element={<Contact />} />
        <Route path="book" element={<Services />} />
        <Route path="discover" element={<DiscoverPage />} />
        <Route path="privacy" element={<Policies />} />
        <Route path="terms" element={<Terms />} />
        <Route path="cookie" element={<Cookie />} />

      </Route>

      {/* 404 */}
      <Route path="*" element={<h1>404</h1>} />

    </Routes>
  );
}

export default App;